import Vue from 'vue';
import Vuex from 'vuex';
import state from './state.js';
import actions from './actions.js';
import mutations from './mutations.js';
import getters from './getters.js';
Vue.use(Vuex);

const store = new Vuex.Store({
  getters,
  state,
  mutations,
  actions
})
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js